module.exports = __webpack_public_path__ + "static/media/organisms.a1483a82.csv";